module.exports = __webpack_public_path__ + "assets/img/3.91c25812.png";